import React from 'react';
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useI18n } from '../i18n/I18nContext';
import { getLocalizedPath } from '../i18n/localizedRoutes';
import "./WindBallShowcase.css";

/**
 * WindBallShowcase
 * - Polished hero-style product block for the homepage
 * - Styling lives in WindBallShowcase.css (no Tailwind dependency)
 * - Drop-in: <WindBallShowcase />            standalone
 *            <WindBallShowcase variant="hero" />  rendered inside HeroSection (image only)
 */
export default function WindBallShowcase({ variant = "default" }) {
  const { t, locale } = useI18n();
  const product = {
    title: "Wind Ball",
    imageSrc: "/images/Wind Ball/Clear.jpg",
    ctaLink: "/store/wind-ball",
  };

  const isHero = variant === "hero";

  return (
    <section className={`windball-showcase${isHero ? " windball-showcase--hero" : ""}`}>
      {!isHero && (
        <motion.div
          aria-hidden
          className="windball-orb"
          initial={false}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.1 }}
        />
      )}

      <div className="windball-grid">
        <motion.div
          className="windball-image-container"
          initial={false}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7 }}
        >
          <div className="windball-image-card">
            <img
              src={product.imageSrc}
              alt={t('windball.alt')}
              className="windball-image"
              loading="eager"
              fetchpriority={isHero ? "high" : undefined}
            />
          </div>
        </motion.div>

        {!isHero && (
          <motion.div
            className="windball-copy"
            initial={false}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            <div>
              <p className="windball-pill">{t('windball.pill')}</p>
              <h2 className="windball-title">{product.title}</h2>
              <p className="windball-subtitle">{t('windball.subtitle')}</p>
            </div>

            <div>
              <Link to={getLocalizedPath(product.ctaLink, locale)} className="windball-cta">
                {t('windball.buy')}
              </Link>
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
}
